import angular from 'angular';
import '../../services/now-serving';
import '../../services/subscription';
import '../../services/globals';
import '../../services/errors';
import '../../services/validation';
import '../../services/third-party-subscription-info';
import '../../services/queue';
import '../../services/area';
import '../../services/identification';
import { countriesWithCodes } from '../../utils/countries-and-codes';
import { isEmpty, get, toUpper, toLower, kebabCase, camelCase, head } from 'lodash';
import { CreatedFromEnum } from '../../utils/createdFromEnum';
import { CalledFromEnum } from '../../utils/calledFromEnum';
import Gender from '../../enums/gender';
import PersonType from '../../enums/personType';
import IdentificationType from '../../enums/identificationType';
import { buildPersonDataFromClientResponse } from '../../utils';

const module = angular.module('whyline.modals.enqueue', [
  'whyline.services.now-serving',
  'whyline.services.subscription',
  'whyline.services.globals',
  'whyline.services.errors',
  'whyline.services.validation',
  'whyline.services.third-party-subscription-info',
  'whyline.factories.socket',
  'whyline.services.queue',
  'whyline.services.area',
  'whyline.services.identification',
]);

const EnqueueController = ($scope, $uibModalInstance, $translate, AreaService, NotificationService, SubscriptionService, GlobalsService, ErrorService, ValidationService, QueueService, PlaceService, OrganizationService, ThirdPartySubscriptionInfoService, enqueueIn, blockUI, currentPlace, currentOrganization, IdentificationService) => {
  'ngInject';
  const place = currentPlace;
  $scope.enterpriseType = place.enterpriseType;

  $scope.currentArea = {
    withoutAppointment: {
      withPriority: true,
      withoutPriority: true
    }
  }

  const currentAreaId = get(enqueueIn, 'areaId', null);
  if (currentAreaId) {
    $scope.currentArea = AreaService.GetOne(currentAreaId);
  }

  $scope.place = currentPlace;

  $scope.countries = countriesWithCodes;

  let enqueueBlock = blockUI.instances.get('enqueueBlock');
  $scope.blockEnqueueButton = false;

  $scope.thirdPartyApi = get(currentOrganization.configuration, 'thirdPartyInfo.getSubscriptionInfo', false);

  $scope.validatePerson = () => {
    if (!ValidationService.validatePerson($scope.person, 'personId')) {
      return;
    }

    ThirdPartySubscriptionInfoService.ValidatePerson($scope.person.idType, $scope.person.id, currentOrganization._id)
      .then(re => {
        if (!isEmpty(re)) {
          $scope.person.id = re.id.toString();
          $scope.person.firstName = re.firstName.toString();
          $scope.person.lastName = re.lastName.toString();
          $scope.person.email = re.email.toString();
        } else {
          const idType = $scope.person.idType;
          const id = $scope.person.id;

          $scope.person = $scope.emptyPerson();
          $scope.person.idType = idType;
          $scope.person.id = id;
        }
      })
      .catch(() => {
        NotificationService.Error($translate.instant('error_search_person'));
      });
    $scope.apiSearch = true;
  };

  const identifications = PlaceService.getIdentificationsForCurrentPlace() || [];

  const selected = identifications.find(id => id.default) || identifications.find(id => isEmpty(id.key));

  $scope.idTypesList = identifications;

  $scope.requestReasonAndMotive = place.configuration.requestReasonAndMotive && (enqueueIn.where !== 'line' || $scope.enterpriseType === 'whyline');

  $scope.reasons = place.configuration.reasons;

  $scope.reasonRequired = place.configuration.reasonRequired;

  $scope.selectedReason = { value: '' };

  $scope.motive = undefined;

  $scope.selectedIdType = {
    value: selected
  };

  $scope.personKeys = Object.keys(PersonType);
  $scope.genderKeys = Object.keys(Gender)
    .filter(gender => gender && gender !== 'none')
    .map(gender => kebabCase(gender));

  $scope.idLimits = {
    physicalPerson: {
      min: 6,
      max: 8,
    },
    legalPerson: {
      min: 9,
      max: 11,
    },
  };

  $scope.submitIdClicked = false;
  $scope.fetching = false;

  $scope.currentGender = '';
  $scope.showGender = false;
  $scope.isLegalPerson = false;
  $scope.currentPerson = PersonType.physicalPerson;
  $scope.minLength = $scope.idLimits[$scope.currentPerson].min;
  $scope.maxLength = $scope.idLimits[$scope.currentPerson].max;
  $scope.responseAll = null;

  $scope.setEnterprise = () => {
    $scope.enterprise = !$scope.enterprise;
    $scope.isLegalPerson = $scope.enterprise;
    $scope.currentPerson = $scope.enterprise ? PersonType.legalPerson : PersonType.physicalPerson;
    $scope.minLength = $scope.idLimits[$scope.currentPerson].min;
    $scope.maxLength = $scope.idLimits[$scope.currentPerson].max;
    $scope.currentGender = '';
    $scope.person.id = '';
    $scope.resetPersonData();
    $scope.person.idType = toLower($scope.isLegalPerson ? IdentificationType.CUIT : IdentificationType.DNI);
    $scope.submitIdClicked = false;
  }

  $scope.setCurrentGender = (newGender) => {
    $scope.currentGender = Gender[camelCase(newGender)];
    $scope.resetPersonData();
    $scope.submitIdClicked = false;
  }

  $scope.keyPressValidate = (event) => {
    event.target.value = event.target.value.trim();
    if (event.target.value.toString().startsWith('0')) {
      event.target.value = trimStart(event.target.value, '0');
    }

    let value = event.target.value;

    if (value.length > $scope.maxLength) {
      event.target.value = value.slice(0, $scope.maxLength);
    }

    $scope.person.id = event.target.value;
    $scope.resetPersonData();
    $scope.submitIdClicked = false;
    $scope.showGender = false;
    $scope.currentGender = '';
  }

  $scope.enableSearch = () => {
    const idLength = !isEmpty(get($scope, 'person.id', ''))
      ? $scope.person.id.length
      : 0;

    const currentPerson = get($scope, 'currentPerson', '')
    const isPhysicalPerson = currentPerson === PersonType.physicalPerson && (!$scope.showGender || !isEmpty($scope.currentGender));
    const isLegalPerson = $scope.isLegalPerson && isEmpty($scope.currentGender);
    const validId = idLength >= $scope.minLength && idLength <= $scope.maxLength;
    const enableSearch = (isPhysicalPerson || isLegalPerson) && validId;
    return enableSearch;
  }

  $scope.submitId = () => {
    if (!$scope.enableSearch()) return;

    // Force temporary id type for initial validation, before send request to external service.
    // After external service responds, we take final identification type and overwrite this one.
    $scope.person.idType = toLower($scope.currentPerson === PersonType.legalPerson
      ? IdentificationType.CUIT
      : IdentificationType.DNI
    );
    if (!ValidationService.validatePerson($scope.person, 'personId', $scope, { timeOut: 10000 }, 'enqueue')) return;

    $scope.responseAll = null;
    
    $scope.submitIdClicked = false;
    IdentificationService
      .Identify(
        $scope.person.id,
        $scope.currentGender,
        currentOrganization._id.toString(), 
        CalledFromEnum.NowServing
      )
      .then(response => {
        if (get(response, 'moreThanOneUser', false) && !$scope.currentGender) {
          $scope.showGender = true;
          $scope.submitIdClicked = false;
          return;
        }
        $scope.submitIdClicked = true;
        $scope.responseAll = response;

        if (get(response, 'client', false)) {
          const person = buildPersonDataFromClientResponse(response);
          $scope.person = { ...person, priority: $scope.person.priority };
        } else {
          NotificationService.Warning($translate.instant('client_identify_error'));
          $scope.resetPersonData();
        }
      })
      .catch(error => {
        $scope.submitIdClicked = true;
        $scope.responseAll = error;
        NotificationService.Warning($translate.instant('client_identify_error'));
        $scope.resetPersonData();
      });

  }

  $scope.resetPersonData = () => {
    $scope.person = Object.assign({}, $scope.person, {
      firstName: '',
      lastName: '',
      phone: {
        countryCode: 'AR',
        full: '',
      },
      email: '',
    });
  };

  $scope.emptyPerson = () => {
    return {
      id: '',
      idType: selected ? selected.key : undefined,
      phone: {
        countryCode: toUpper(place.location.countryCode),
        full: '',
      },
      email: '',
      priority: null
    };
  };

  $scope.person = $scope.emptyPerson();

  if ($scope.currentArea.withoutAppointment.withPriority && !$scope.currentArea.withoutAppointment.withoutPriority) {
    $scope.priority = {
      show: true,
      selectedCategory: 'disabled',
      canBeChanged: false,
    };
    $scope.person.priority = {
      category: $scope.priority.selectedCategory,
    };
  } else {
    $scope.priority = {
      show: false,
      selectedCategory: 'disabled',
      canBeChanged: true,
    };
  }

  // Id Type
  $scope.updateIdType = () => {
    $scope.person.idType = get($scope.selectedIdType, 'value.key', undefined);
  };

  const setPersonPriority = () => {
    if ($scope.priority.show) {
      $scope.person.priority = {
        category: $scope.priority.selectedCategory
      }
    } else {
      $scope.person.priority = null;
    }
  };

  $scope.setPriority = () => {
    $scope.priority.show = !$scope.priority.show;
    setPersonPriority();
  };

  $scope.setPriorityCategory = priorityCategory => {
    $scope.priority.selectedCategory = priorityCategory;
    $scope.person.priority.category = priorityCategory;
  };

  $scope.enqueue = person => {
    const createdFrom = CreatedFromEnum.operator;
    const requestReasonAndMotive = place.configuration.requestReasonAndMotive && (enqueueIn.where !== 'line' || $scope.enterpriseType === 'whyline');
    const requestPriority = currentAreaId && !$scope.currentArea.withoutAppointment.withoutPriority;

    if (!$scope.person.priority) {
      Reflect.deleteProperty($scope.person, 'priority');
    }

    if (requestReasonAndMotive) {
      if ($scope.selectedReason.value === '' || !$scope.selectedReason.value) {
        if (place.configuration.reasonRequired) {
          NotificationService.Warning($translate.instant('select_a_reason_err'));
          return;
        } else {
          enqueueIn = Object.assign(enqueueIn, { motive: $scope.motive });
        }
      } else {
        enqueueIn = Object.assign(enqueueIn, { reason: $scope.selectedReason.value, motive: $scope.motive });
      }
    }

    if (requestPriority && !$scope.person.priority) {
      NotificationService.Warning($translate.instant('select_a_priority_err'));
      return;
    }

    if (ValidationService.validatePerson(person, 'personId')
      && ValidationService.validatePerson(person, 'name') 
      && ValidationService.validatePerson(person, 'phone') 
      && ValidationService.validatePerson(person, 'email') 
      && !$scope.blockEnqueueButton) {
      $scope.blockEnqueueButton = true;
      enqueueBlock.start('Creando suscripción...');

      SubscriptionService.Create(person, enqueueIn, createdFrom)
        .then(() => {
          delete enqueueIn.reason;
          delete enqueueIn.motive;
          NotificationService.Success($translate.instant('user_add_fila_succ'));
          enqueueBlock.stop();
          $scope.blockEnqueueButton = false;
          $scope.cancel();
        })
        .catch(err => {
          ErrorService.handler(err);
          enqueueBlock.stop();
          $scope.blockEnqueueButton = false;
          $scope.cancel();
        });
    }
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.preventSpace = event => {
    if (event.keyCode === 32) {
      event.preventDefault();
    }
  }
};

module.exports = module.controller('EnqueueController', EnqueueController);
